// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","serviceProviders":"_3VVevFxd66GcL21SmvaQr9","serviceProviderMainArea":"_3aUo-WnT-I66E_6LiAxXxG","serviceProviderColumn":"_1gv8WMuQP1XdMFmrlrEByx"};